import ApiService from '../api.services';

const PrepostProductsService = {
  get: async function (id) {
    try {
      const response = await ApiService.get(`/api/prepost/content/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  update: async function (id, data) {
    try {

      const res = await ApiService.patch(`/api/prepost/content/${id}`, data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
};

export default PrepostProductsService;

export { PrepostProductsService };

